export type CountdownCallback = () => void;

export const startCountdown = (
  initialCount: number,
  onTick: (count: number) => void,
  onComplete: CountdownCallback,
): (() => void) => {
  let currentCount = initialCount;

  const countdownInterval = setInterval(() => {
    currentCount--;

    if (currentCount <= 0) {
      clearInterval(countdownInterval);
      onComplete();
    } else {
      onTick(currentCount);
    }
  }, 1000);

  return () => clearInterval(countdownInterval);
};

export const createAlignmentChecker = (
  checkAlignment: () => boolean,
  onAlignmentChange: (isAligned: boolean) => void,
  interval = 500,
): (() => void) => {
  const alignmentInterval = setInterval(() => {
    const aligned = checkAlignment();
    onAlignmentChange(aligned);
  }, interval);

  return () => clearInterval(alignmentInterval);
};

export const createSafeAlignmentChecker = (
  checkAlignment: () => boolean,
  onAlignmentChange: (isAligned: boolean) => void,
  interval = 500,
  maxErrors = 3,
): (() => void) => {
  let cleanup: (() => void) | null = null;
  let errorCount = 0;

  const wrappedCheckAlignment = () => {
    try {
      const result = checkAlignment();
      errorCount = 0;
      return result;
    } catch (err) {
      console.error('CheckAlignment error:', err);
      errorCount += 1;

      if (errorCount >= maxErrors) {
        console.warn('Too many errors, restarting alignment checker...');
        if (cleanup) cleanup();
        errorCount = 0;

        cleanup = createAlignmentChecker(
          wrappedCheckAlignment,
          onAlignmentChange,
          interval,
        );
      }

      return false;
    }
  };

  cleanup = createAlignmentChecker(
    wrappedCheckAlignment,
    onAlignmentChange,
    interval,
  );

  return () => {
    if (cleanup) cleanup();
  };
};
